import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { AdminDashboardDetailModel, IAdminDashboardDetailDTO } from "../models/dashboard/adminDashboardDetailDTO";
import { MapAnalystDetailModel } from "../models/dashboard/mapAnalystDetailDTO";
import { AnalystDashboardDetailModel, IAnalystDashboardDetailDTO } from "../models/dashboard/analystDashboardDetailDTO";
import { ClientDashboardDetailModel, IClientDashboardDetailDTO } from "../models/dashboard/clientDashboardDetailDTO";
let AppDashboardModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e;
    let AppDashboardModule = class AppDashboardModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "dashboard";
            this.isPageLoading = false;
            this.adminDetail = null;
            this.analystDetail = null;
            this.clientDetail = null;
        }
        async GetDashboardDetails() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetAdminDashboardDetail(plainToClass(AdminDashboardDetailModel, data.adminDetail));
                this.SetAnalystDashboardDetail(plainToClass(AnalystDashboardDetailModel, data.analystDetail));
                this.SetClientDashboardDetail(plainToClass(ClientDashboardDetailModel, data.clientDetail));
                return data;
            }
        }
        async GetMapAnalystDetails() {
            var url = `${getTenantId()}/${this.apiNode}/map-analyst-details`;
            let { data } = await service.get(url);
            if (data) {
                this.SetMapAnalystDetails(plainToClass(MapAnalystDetailModel, data.mapAnalystDetails));
                return data;
            }
        }
        SetIsPageLoading(value) {
            this.isPageLoading = value;
        }
        SetAdminDashboardDetail(adminDetail) {
            if (adminDetail) {
                this.adminDetail = adminDetail;
                if (this.adminDetail.mapStates) {
                    var maxValue = Math.max(...this.adminDetail.mapStates.map((x) => x.entriesCount));
                    this.adminDetail.mapStates.forEach((x) => {
                        var value = x.entriesCount / maxValue;
                        x.percentage = (value * 85 + 15) / 100;
                        // Refer Link for formula - https://chatgpt.com/share/82ad6fe8-8165-4799-bd9a-81f26d22e1bc
                    });
                }
            }
        }
        SetAnalystDashboardDetail(analystDetail) {
            if (analystDetail) {
                this.analystDetail = analystDetail;
                if (this.analystDetail.mapStates) {
                    var maxValue = Math.max(...this.analystDetail.mapStates.map((x) => x.entriesCount));
                    this.analystDetail.mapStates.forEach((x) => {
                        var value = x.entriesCount / maxValue;
                        x.percentage = (value * 85 + 15) / 100;
                    });
                }
            }
        }
        SetClientDashboardDetail(clientDetail) {
            if (clientDetail) {
                this.clientDetail = clientDetail;
                if (this.clientDetail.mapStates) {
                    var maxValue = Math.max(...this.clientDetail.mapStates.map((x) => x.entriesCount));
                    this.clientDetail.mapStates.forEach((x) => {
                        var value = x.entriesCount / maxValue;
                        x.percentage = (value * 85 + 15) / 100;
                    });
                }
            }
        }
        SetMapAnalystDetails(mapAnalystDetails) {
            this.adminDetail.mapAnalystDetails = mapAnalystDetails;
            this.adminDetail.mapAnalystDetails.forEach((x) => {
                var maxValue = Math.max(...x.states.map((x) => x.entriesCount));
                x.states.forEach((y) => {
                    var value = y.entriesCount / maxValue;
                    y.percentage = (value * 85 + 15) / 100;
                });
            });
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], AppDashboardModule.prototype, "GetDashboardDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], AppDashboardModule.prototype, "GetMapAnalystDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AppDashboardModule.prototype, "SetIsPageLoading", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof IAdminDashboardDetailDTO !== "undefined" && IAdminDashboardDetailDTO) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], AppDashboardModule.prototype, "SetAdminDashboardDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof IAnalystDashboardDetailDTO !== "undefined" && IAnalystDashboardDetailDTO) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], AppDashboardModule.prototype, "SetAnalystDashboardDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof IClientDashboardDetailDTO !== "undefined" && IClientDashboardDetailDTO) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], AppDashboardModule.prototype, "SetClientDashboardDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], AppDashboardModule.prototype, "SetMapAnalystDetails", null);
    AppDashboardModule = __decorate([
        Module({ dynamic: true, store: store, name: "dashboard", namespaced: true })
    ], AppDashboardModule);
    return AppDashboardModule;
})();
export const DashboardModule = getModule(AppDashboardModule);
